import { Helmet } from 'react-helmet';
import Profile from '../../components/profile/Profile';
import useFetchCredential from '../../hooks/useFetchCredential';

const ProfilePage = () => {
  const { data, loading, error } = useFetchCredential(
    `${process.env.REACT_APP_API_URL}/marketers/dashboard`
  );
  const {
    data: refData,
    loading: refLoading,
    error: refError,
  } = useFetchCredential(`${process.env.REACT_APP_API_URL}/marketers/referral-profile`);

  console.log('refData', refData);
  return (
    <>
      {data && refData && (
        <>
          <Helmet>
            <meta charSet="utf-8" />
            <title> {data.fName}'s Profile - Global Triumph Market Plus Multiconcept</title>
            <meta
              name="description"
              content="User profile page on Global Triumph Market Plus Multiconcept - Real estate investments and properties, properties for sales"
            />
          </Helmet>
          <div className="profile">
            <h1 className="pageTitle">
              {data.fName} {data.lName} Profile
            </h1>
            <h3 className="subtitle">You can see information about your account here</h3>
            <Profile data={data} refData={refData} />
          </div>
        </>
      )}
      {loading && <div style={{ color: 'red !important', fontSize: '25px' }}>Loading...</div>}
      {refLoading && <div style={{ color: 'red !important', fontSize: '25px' }}>Loading...</div>}
      {error && <div style={{ color: 'red !important', fontSize: '25px' }}>{error}</div>}
      {refError && <div style={{ color: 'red !important', fontSize: '25px' }}>{refError}</div>}
    </>
  );
};

export default ProfilePage;
